(function ($) {
  ///// ON READY /////
  $(function () {
    var vtx_sliders = new VTX_Sliders('.carousel__activity-featured', {
      // Optional parameters
      slidesPerView: 'auto',
      spaceBetween: 20,
      direction: 'horizontal',
      breakpoints: {
        // when window width is >= 480px
        600: {
          slidesPerView: 'auto',
          spaceBetween: 30
        },
        // when window width is >= 640px
        980: {
          slidesPerView: 'auto',
          spaceBetween: 30
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 'auto',
          spaceBetween: 60
        }
      },
      navigation: {
        nextEl: '.activity-featured__pagination .swiper-button-next',
        prevEl: '.activity-featured__pagination .swiper-button-prev'
      },
      pagination: {
        el: '.activity-featured__pagination .swiper-pagination',
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          console.log(index, className);
          return '<span class="' + className + '"> 0' + (index + 1) + '</span>';
        }
      }
    });
    console.log(vtx_sliders);
  }); // end READY
})(jQuery);